'use client';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';
import { Button } from '@/app/components/_catalyst/button';
import { Text } from '@/app/components/_catalyst/text';
import { useTranslation } from '@/app/i18n/client';
import { errorTracker } from '../services/errorTracking';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const params = useParams<{ lng: string }>();
  const { t } = useTranslation(params.lng, 'error');

  useEffect(() => {
    errorTracker.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="space-y-4">
          <Text className="text-cPrimary text-4xl font-bold tracking-tight sm:text-5xl dark:text-white">
            {t('title')}
          </Text>
          <Text className="text-base">{t('description')}</Text>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button onClick={() => reset()}>{t('tryAgain')}</Button>
          <Button href={`/${params.lng}/dashboard`} outline>
            {t('goToDashboard')}
          </Button>
        </div>
      </div>
    </div>
  );
}
